export type PaginationToken = number | 'ellipsis'

export function buildVisiblePageNumbers(currentPage: number, totalPages: number): PaginationToken[] {
  const safeTotalPages = Math.max(totalPages || 1, 1)
  const safeCurrentPage = Math.min(Math.max(currentPage || 1, 1), safeTotalPages)

  if (safeTotalPages <= 7) {
    return Array.from({ length: safeTotalPages }, (_, index) => index + 1)
  }

  const pages: PaginationToken[] = [1]
  const start = Math.max(2, safeCurrentPage - 1)
  const end = Math.min(safeTotalPages - 1, safeCurrentPage + 1)

  if (start > 2) {
    pages.push('ellipsis')
  }

  for (let page = start; page <= end; page += 1) {
    pages.push(page)
  }

  if (end < safeTotalPages - 1) {
    pages.push('ellipsis')
  }

  pages.push(safeTotalPages)
  return pages
}

export function getTotalPages(itemCount: number, pageSize: number): number {
  if (!pageSize || pageSize <= 0) {
    return 1
  }

  return Math.max(Math.ceil(itemCount / pageSize), 1)
}
